var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('checklist.sidebar.shortTitle'),"logo":_vm.$store.getters.systemLogoSidebar,"titleImg":_vm.$store.getters.systemTitleImage,"title":_vm.$store.getters.systemTile}},[_c('template',{slot:"links"},[(_vm.$store.getters.isCargoKanbamAvaliable)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.kanbanCargas'),
            icon: 'tim-icons icon-chart-pie-36',
            path: '/trackingShippingCompany/cargo/kanban', // '/trackingShippingCompany/dashboard/default',
          }}})],1):_vm._e(),(_vm.$store.getters.isCargoExpensesAvaliable)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.kanbanFinanceiro'),
            icon: 'tim-icons icon-chart-bar-32',
            path: '/trackingShippingCompany/cargoExpense/kanban',
          }}})],1):_vm._e(),(_vm.$store.getters.hasAccessCompany == true)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.empresas'),
            path: '/trackingShippingCompany/company/list',
            icon: 'tim-icons icon-bank',
          }}})],1):_vm._e(),(_vm.$store.getters.hasAccessUser == true)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.usuarios'),
            path: '/trackingShippingCompany/user/list',
            icon: 'tim-icons icon-single-02',
          }}})],1):_vm._e(),(_vm.$store.getters.hasAccessProfile == true)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('system.profile.sidebar'),
            path: '/trackingShippingCompany/profile/all',
            icon: 'tim-icons icon-single-02',
          }}})],1):_vm._e(),(_vm.isMasterAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('system.module.sidebar'),
          path: '/trackingShippingCompany/module/all',
          icon: 'tim-icons icon-components',
        }}}):_vm._e(),(_vm.$store.getters.hasAccessTypeOccurrence == true)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.tracking.occurrenceType'),
            path: '/trackingShippingCompany/occurrenceType/list',
            icon: 'tim-icons icon-notes',
          }}})],1):_vm._e(),(_vm.$store.getters.hasAccessTypeOccurrenceExpense == true)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.tracking.cargoExpenseOccurrence'),
            path: '/trackingShippingCompany/cargoExpenseOccurrence/list',
            icon: 'tim-icons icon-coins',
          }}})],1):_vm._e(),(_vm.$store.getters.hasAccessTypeVehicle == true)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.tracking.vehicleType'),
            path: '/trackingShippingCompany/vehicleType/list',
            icon: 'tim-icons icon-delivery-fast',
          }}})],1):_vm._e(),(_vm.$store.getters.hasAccessLoads == true)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.tracking.cargo'),
            path: '/trackingShippingCompany/cargo/list',
            icon: 'tim-icons icon-app',
          }}})],1):_vm._e(),_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.tracking.rotogram'),
            icon: 'tim-icons icon-square-pin',
            path: '/trackingShippingCompany/cargo/rotogram',
          }}})],1),(_vm.$store.getters.hasAccessNonAttendanceReason == true)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.tracking.nonAttendanceReason'),
            path: '/trackingShippingCompany/nonAttendanceReason/list',
            icon: 'tim-icons icon-paper',
          }}})],1):_vm._e(),(_vm.$store.getters.isAdministrator == true)?_c('div',[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('tracking.disapprovedReason.sidebar'),
            path: '/trackingShippingCompany/disapprovedReason/list/',
            icon: 'tim-icons icon-paper',
          }}})],1):_vm._e()],1)],2),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar',{attrs:{"module":"trackingShippingCompany"}}),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }